import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogDisplayCommunityBanner = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (goodsSno: number) => {
      logAnalyticsEvent({
        name: 'DISPLAY_COMMUNITY_BANNER',
        channel: ['firebase', 'facebook', 'ablylog'],
        analytics: {
          GOODS_SNO: goodsSno,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
